'use client';

import dynamic from 'next/dynamic';

export const SquashStretchBall = dynamic(
  () => import('./SquashStretchBall')
);
export const StretchyArrowDemo = dynamic(
  () => import('./StretchyArrowDemo')
);
// NOTE: Currently unused?
// export const DownloadIconDemo = dynamic(
//   () => import('./DownloadIconDemo')
// );
export const StretchyArrowComparisonDemo = dynamic(
  () => import('./StretchyArrowComparisonDemo')
);
export const StretchySpringVsBezierDemo = dynamic(
  () => import('./StretchySpringVsBezierDemo')
);
export const StretchyStateVsActionDemo = dynamic(
  () => import('./StretchyStateVsActionDemo')
);
